<script>
export default {
  name: 'InjectEditorPracticeJs',
  methods: {
    loadJs() {
      const that = this
      const jsDir = '/js'
      const aceDistDir = jsDir + '/ace-build/src'
      const acejs = aceDistDir + '/ace.js'
      const aceThemeJs = aceDistDir + '/theme-cobalt.js'
      const acePythonModeJs = aceDistDir + '/mode-python.js'
      const aceCppModeJs = aceDistDir + '/mode-c_cpp.js'
      const aceJavaModeJs = aceDistDir + '/mode-java.js'
      const acePascalModeJs = aceDistDir + '/mode-pascal.js'
      const aceExtLanguageToolsJs = aceDistDir + '/ext-language_tools.js'
      const gameDir = 'static/game'
      const gameBuildDir = gameDir + '/Build'
      const gameJsDir = gameDir + '/js'
      const gameBuildJs = gameBuildDir + '/Build.loader.js'
      const gameJSCPPjs = gameJsDir + '/JSCPP.es5.min.js'
      const gameJscppRun = gameJsDir + '/jscppRun.js'
      const skulpt = gameJsDir + '/skulpt.min.js'
      const skulptStdlib = gameJsDir + '/skulpt-stdlib.js'
      const skulptpy = gameJsDir + '/skulptpy.js'
      const gamePyApi = gameJsDir + '/gamepy_api.js'
      const gameUnityCallJs = gameBuildDir + '/UnityCallJs.js'
      const gameJsCallUnity = gameBuildDir + '/JsCallUnity.js'
      const gameApiJs = gameDir + '/clang/game_api.js'
      const sharedJs = gameDir + '/clang/shared.js'
      const sharedWebJs = gameDir + '/clang/shared_web.js'
      this.$loadScript(acejs).then(() => {
        //   return that.$loadScript(that.$g.URL.jqconsole)
        // }).then(() => {
        //   return that.$loadScript(that.$g.URL.editormdMinJs)
        // }).then(() => {
        //   return that.$loadScript(that.$g.URL.JsCppMin)
        // }).then(() => {
        //   return that.$loadScript(that.$g.URL.skulptMin)
        // }).then(() => {
        //   return that.$loadScript(that.$g.URL.skulptStdlib)
        // }).then(() => {
        //   return that.$loadScript(that.acejs)
      }).then(() => {
        return that.$loadScript(aceThemeJs)
      }).then(() => {
        return that.$loadScript(acePythonModeJs)
      }).then(() => {
        return that.$loadScript(aceCppModeJs)
      }).then(() => {
        return that.$loadScript(aceJavaModeJs)
      }).then(() => {
        return that.$loadScript(acePascalModeJs)
      }).then(() => {
        return that.$loadScript(aceExtLanguageToolsJs)
      }).
      // then(() => {
      //   return that.$loadScript(gameBuildJs)
      // }).then(() => {
      //   return that.$loadScript(gameJSCPPjs)
      // }).then(() => {
      //   return that.$loadScript(gameJscppRun)
      // }).then(() => {
      //   return that.$loadScript(skulpt)
      // }).then(() => {
      //   return that.$loadScript(skulptStdlib)
      // }).then(() => {
      //   return that.$loadScript(skulptpy)
      // }).then(() => {
      //   return that.$loadScript(gamePyApi)
      // }).then(() => {
      //   return that.$loadScript(gameUnityCallJs)
      // }).then(() => {
      //   return that.$loadScript(gameJsCallUnity)
      // }).then(() => {
      //   return that.$loadScript(gameApiJs)
      // }).then(() => {
      //   return that.$loadScript(sharedJs)
      // }).then(() => {
      //   return that.$loadScript(sharedWebJs)
      // }).
      then(() => {
        this.$emit('injectJSFinish', true)
      }).catch((err) => {
        // Failed to fetch script
        console.log(err)
      })
    }
  },
  render: function(createElement) {
    const that = this
    that.loadJs()
    return createElement('div', [])
  }
}
</script>
